module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "prologue"
    }
  }), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    staticClass: "nounderb",
    attrs: {
      "href": "#/xhtml/cont#cont"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Prologue")])])])]), _vm._v(" "), _c('p', {
    staticClass: "h2title"
  }, [_vm._v("Sometimes You Just Have to Go for Broke")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("O")]), _vm._v("ne of my first memories involves two of my favorite places: the Plaza Hotel and New York City.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I was eight years old. My mother, Scarlett Macon Davenport, a proud Southern belle from her Aqua Net–lacquered bob down to her perfectly polished Chanel ballet flats, decided it was about time she and I got out of Charleston, South Carolina, and had ourselves a “girls’ trip.” Apparently, there was no better place in the world to do “girly” things—shopping, giggling, being all-around glamorous and frivolous—than the island of Manhattan.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She tracked me down in the sunroom of our family home, Magnolia Gate, a grand, Georgian-style estate just outside of Charleston. It was a bona fide plantation with red brick and white pillars and a mile-long driveway lined with, yes, magnolia trees. It had been handed down in my father’s family for five generations.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When I wasn’t playing tennis, I spent my afternoons in my mother’s sunroom poring over her latest copies of "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Vogue, Harper’s Bazaar")]), _vm._v(", "), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("and "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Elle")]), _vm._v(". I would carefully cut out the most beautiful photos and paste them onto large sheets of poster board, creating collages of inspiration like my mother did for her interior design clients.")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ve bought us two tickets to New York City, Minty,” my mother said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She stood over me with her hands on her hips. Although she rarely left home without putting on a dress, she was partial to cashmere turtlenecks and slacks when she was hanging around the house. That day her outfit was entirely white—“winter white,” as she called it—except for her monogrammed velvet slippers, which were black with white lettering. She had her cat-eye glasses on, the ones that made her look smart and authoritative, like a chic librarian.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’ll visit Santa Claus,” she continued. “We’ll go shopping at Saks Fifth Avenue. We’ll stay at the Plaza, of course.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I was sprawled out on the floor barefoot, wearing a pink plaid jumper and wool tights. I had pink satin ribbons woven through my French-braided hair. I always had ribbons to match my outfit, which meant I always had pink ribbons. Up until that point, I hadn’t been paying much attention to what my mother was saying. I was too caught up in one of my latest creations, a colorful mishmash pulled from the pages of an old "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Mademoiselle")]), _vm._v(". Flat on the poster board, Lauren Hutton stared up at me from an Ultima II perfume ad, smiling. Next to her, I’d laid out a photo of Grace Jones, the fierce, exotic yang to Lauren’s all-American yin. I was in the midst of cutting up a Brooke Shields Calvin Klein ad when I heard the words “the” and “Plaza.” I put down my scissors.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The Plaza "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Hotel")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, Minty.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("real")]), _vm._v(" Plaza?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“As opposed to the fake one?” my mother replied.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The Plaza.” I stood up. “Where Eloise lives?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A tiny hint of a smile spread across my mother’s face.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Where else would we stay, Minty?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("My grandmother gave me my first Eloise book when I was born and I have been obsessed ever since. In fact, they are the only books I ")]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("have ever "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("truly")]), _vm._v(" enjoyed reading to this day and I still leaf through their pages once a week.")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("At eight years old, Eloise had already made an indelible impact on my young life. I aspired to dress in a jumper like Eloise, to speak on the telephone like Eloise, to order room service like Eloise. I wanted to "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("be")]), _vm._v(" Eloise, or at the very least make her my friend. But most of all, I wanted to live like Eloise.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Through my tiny, fictional idol, I had come to the conclusion that not only was the Plaza the most incredible, glamorous, over-the-top, wonderful, delightful place in the world to be, it was the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("only")]), _vm._v(" place to be.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And it just so happened to be in New York City.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I considered my options for about thirty seconds, during which my mother rolled her eyes and crossed her arms over her chest rather dramatically.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mary Randolph Mercer Davenport. Today?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mary Randolph was my grandmother’s name. Mary was my “official” first name, but I’d been called “Minty” since before I can remember. No one can ever recall the specifics, but it has something to do with the fact that I’d loved candy as a child, especially the red-and-white swirly “starlight” mints.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“All right, Mommy,” I finally said. “Let’s go to New York.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A rosy flush spread over my mother’s cheeks. She looked like a little girl about to open a present.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re going to just love it, Minty,” she said, her voice taking on the hushed and sacred tone of our priest at church. “New York City is a magical place.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Eloise lives there,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes,” my mother replied. “Yes, she does.”")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "6",
      "src": "images/common.jpg",
      "width": "100"
    }
  })])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("A")]), _vm._v(" week later, I stood next to my mother as she helped our longtime driver, Claude, pack up the car with her vintage Louis Vuitton luggage collection. By the looks of it, we were leaving Charleston for good, but many of the trunks were empty and would come back filled ")]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("with Christmas presents for my younger sister, Darby, and me as well as the latest designer creations for my mother’s spring wardrobe.")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I slid into the back of the car, clutching a small Lanvin purse my mother had let me borrow for the weekend. I had filled it with Blow Pops and two sheets of sparkly stickers shaped like high heels and handbags.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, good afternoon, Miss Minty,” Claude said from the driver’s seat, looking at me through the rearview mirror.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Claude was almost like a grandfather to me. He had weathered, sun-beaten skin so soft it felt like vintage velvet. It was the color of a sun-ripened peach, warm and ruddy. His lips were always curled up in a broad, white smile, but his eyes were solemn and thoughtful.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I liked Claude for many reasons, most of all because he always kept starlight mints in his pocket for me. If we were all driving together and my mother happened to be otherwise engaged, which she often was, Claude would extend his arm toward the backseat and present a mint to me in his open palm—a tiny secret between the two of us. I loved the mints so much that my mother often caught me sucking away at several at once, tiny rivulets of red running down the sides of my mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So, New York City, eh, Miss Minty?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, Claude,” I said in a very authoritative tone. I crossed my legs at my ankles, a mannerism that had been drilled into me since I was old enough to sit up on my own.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What are you going to do there?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Eat candy,” I replied. “And Mommy will shop.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Claude laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("From my perch in the backseat, the front of our house was obscured, but I could hear my mother’s high-pitched Southern drawl making its way down the walkway. “And I will not have that child eating Froot Loops for dinner, Gharland. You hear me, now?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Darby, honey,” she said, addressing my younger sister. “You’ll come next time. You’ll have a nice time with Daddy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Darby was six at the time and a bit too young to really understand what she would be missing, but she was putting up a fit anyway. I peered around the side of Claude’s seat until I could make out my father, who was holding a squirming Darby.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Next year, Darby,” my mother cooed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’ll go to the movies, honey,” my father chimed in.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My father was always an impossibly handsome man and still is today. He has deep-set eyes with a strong jawline and thick, dark hair that curls up a bit at the ends. Now it’s nearly white, but back then it was the color of molasses, so intensely brown it almost appeared black. He’s nearly six foot four with broad shoulders and the rounded stomach of a thrice-daily bourbon drinker. My mother always said, “He fills out a suit nicely,” and he does.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My parents met at my mother’s debutante ball in Savannah, Georgia, where she grew up. Their first introduction was far from romantic. As the escort of an infinitely less beguiling young lady (my mother loves telling this story, and with each telling the young lady becomes less and less beguiling) named Hayley Beaufort, my father was reluctant to attend the ball at all. So, he had spent the two hours from Charleston to Savannah shooting bourbon in the backseat of his friend’s father’s Mercedes and arrived on the scene in a state of inebriation so severe that he had to be carried into the men’s room and doused with several rounds of water.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When he appeared in the ballroom over an hour later, he was slapped in the face by Hayley, given a stern talking-to by Hayley’s father, and sent to sit at their table alone to atone for his sins.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My father had already established quite the name for himself as a notorious charmer and “finagler” (this is a word my mother still uses to describe him) who had made a sport of bedding young debutantes around Charleston and Savannah. He was known to feign undying love for a few weeks’ time, taking the young ladies home to meet his parents, writing them intricate letters and sending flowers, jewelry, and clothing as tokens of his appreciation, and then flat dropping them when his interest inevitably waned.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He had recently done just this to one of my mother’s closest and dearest friends, and my mother was not about to let a chance to reprimand him slip out of her fingers.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("From the dance floor, she watched out of the corner of her eye as my father sat there, dumbfounded, his hair still wet from his dousing in the bathroom, his cheek still stinging. When the waltz ended, she walked right over and gave him a piece of her mind.")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("When she finished her tirade, he looked up at her and raised an eyebrow. “My God you’re beautiful,” he said. “What is your name?”")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "6",
      "src": "images/common.jpg",
      "width": "100"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("U")]), _vm._v("ntil that moment, when Darby wailed and screamed and punched my father with tiny fists, I had never seen him in anything less than perfect control. But that day he looked terrified, as if my mother and I were abandoning him to Satan’s spawn.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Newark!” Darby was screaming over and over. The correct pronunciation of “New York” eluded her, and she had resorted to shrieking the name of a far less desirable city in New Jersey. “"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Newaaaark!")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Claude caught my eye in the rearview mirror and we burst into a fit of laughter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Good Lord in the heavens above.” My mother’s slim frame appeared in the seat next to me. She had on large, black sunglasses. On her lap, she placed one of her signature quilted Chanel purses and folded her hands over it with such grace and care you might have thought it was a living, breathing entity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let’s get the hell out of here, Claude,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Just as we were about to start backing up, my mother rolled down the window and allowed my father to stick his head in. This was a little ritual of his—a final word before the departure. He bent over with his left arm behind him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Y’all behave yourselves, all right?” he said, his blue eyes sparkling.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My mother turned and shot him a glance. “Ha!” she said. “We will do no such thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She rolled up the window and signaled to Claude.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As the car pulled out of the driveway, I could hear my father’s laugh, low and bellowing through the thick glass of the Cadillac’s tinted windows.")])]), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "6",
      "src": "images/common.jpg",
      "width": "100"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("I")]), _vm._v(" don’t remember much of the plane ride. I remember grasping my mother’s hand as we navigated the long corridors of JFK. My mother stopped at one shop to buy her favorite Dior perfume and allowed me to spray myself with a bit of Shalimar, which made me cough and wheeze for the majority of the cab ride into Manhattan.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When the cab pulled up to the entrance of the hotel, the first thing I noticed was the row of perfectly groomed carriage horses. Then I saw the lights, the bellmen in pressed suits and hard round caps, the plush carpet, the sparkling glass, and the shimmering carved wood. I stood in the lobby and looked around, feeling as if someone had dropped me into a genie bottle.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Welcome to the Plaza Hotel, Miss Davenport,” a man said as my mother and I checked in.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He leaned over and handed me a lollipop. I almost told him I already had one in my purse, but I knew it would have been rude not to accept a present (the correct word was “present,” not “gift,” my mother always told me).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My mother caught my eye and smiled at me sternly, as if to say, "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Go on and thank the man now, Minty")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thank you, sir,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The same bellman gathered our many bags and guided us toward a set of elevators. He told us that the Plaza had twenty floors and that we would be staying on the eighteenth floor in the Royal Terrace Suite, which featured a view of Central Park. I was only half-listening, of course. I was on the lookout for Eloise. I thought she might come running down the hallway at any moment and try to steal my lollipop.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Is this your first time in New York City?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We were in the elevator, climbing the floors one by one, and the bellman was posing this question to me, but I was not listening.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Minty,” my mother said. “Answer the nice man.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I must have jumped a little, because the man laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What are you thinking about now, little miss?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("I looked up, eyes wide and fueled by sugar. I answered with the ")]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("first thought that came to my mind, which was the truth. “Eloise,” I said.")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“I thought you might be looking for her,” the bellman said. Then he leaned down and whispered, just loud enough that my mother could hear as well. “You just missed her in the Palm Court.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I had "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("just")]), _vm._v(" missed her? I had come all this way to New York City and just "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("narrowly")]), _vm._v(" missed seeing and meeting Eloise?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’ll look for her tomorrow, Minty,” my mother said, stepping off the elevator. She exchanged a wink with the bellman.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I narrowed my eyes at both of them. The bellman directed us toward a door at the end of the hallway. It was heavy and old and had a brass plaque that read ROYAL TERRACE SUITE. He opened the door and deposited our luggage. Then he bowed slightly and let himself out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My mother and I held hands and looked out the windows of the suite, past the sumptuous silk faille curtains and onto Central Park. I felt both awed and frightened by what lay past our window. The park seemed dark and sprawling, almost ominous without the benefit of daylight. “Time to go to sleep now, Minty,” my mother said. “We have a full schedule ahead of us tomorrow.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As she tucked me in, she rattled off a to-do list for the following day: breakfast in the Edwardian Room, shopping at Bergdorf Goodman, a stroll down Fifth Avenue, a stop into St. Patrick’s Cathedral, lunch at La Grenouille, more shopping at Saks. I drifted off into a deep sleep and dreamed about finding Eloise.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "6",
      "src": "images/common.jpg",
      "width": "100"
    }
  })])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('span', {
    staticClass: "biga"
  }, [_vm._v("N")]), _vm._v("ow, fourteen years later, I was back. Except this time, I’d left my mother in Charleston and my sister at Ole Miss. My parents divorced when I was in high school. My mother fought long and hard for Magnolia Gate and, in the end, won the right to stay there under the condition that the property would be left to my sister and me in her will. My father spends his days now playing golf in Palm Beach and has since gone back to his debutante days, breaking hearts. My mother ")]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("often says, “You can’t teach an old dog new tricks, and your father has always been an old dog.”")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I graduated from UNC Chapel Hill in the spring, cum laude, and immediately set my sights on New York City. It was the only place I ever wanted to be. Plus, I’d broken up with my high school sweetheart Ryerson Bigelow the year before, and I was still struggling with the fact that we weren’t together. We’d fallen in love when I was a sophomore in high school and he was a senior, but we’d known each other for far longer. It just happened one day. I was walking home from school on a perfect fall day in Charleston. He came out of nowhere and tackled me into a pile of leaves. When I got my bearings again, I started hysterically laughing, and we kissed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Later, he told me it was my reaction that made him realize I was different from the other girls.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Anyone else would have been furious with me,” he said. “You were such a good sport, I couldn’t help but fall in love with you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We were inseparable for six years after that.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And then, suddenly, we were over. I still wasn’t quite sure exactly where things went wrong. He’d graduated from UVA and our relationship began to suffer. In the end, he told me he wasn’t ready to settle down and get married. The last I’d heard he was traveling around Africa. I couldn’t imagine staying in the South, where everything reminded me of my former life with him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So I set my sights on a career in fashion—the only thing I’d ever been good at, besides tennis, of course. Luckily, New York was the center of the fashion universe. I was determined to turn my dreams into reality.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My mother was skeptical at first.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“New York, Minty?” she said. “What on earth are you going to do there?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Get a job in fashion!” I said, annoyed. She’d heard me say this a million times by then.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("She shook her head. “Can’t you do that in Charleston? We’ve got ")]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("our own Madison Avenue right here on King Street. You could open your own shop and—” She paused. “This isn’t about Ryerson, is it?”")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mommy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She crossed her thin alabaster arms over her chest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“As long as you’re not running away from something,” she said, her eyes narrowing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I scoffed. “It’s been over a year, Mother.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Very well then,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It only took a few calls to some of her clients with apartments in New York before she was able to land an apartment in a “respectable” doorman building on the Upper East Side (although, she noted, “the address is east of Park Avenue, so we will have to do something about that eventually”). And a few weeks later, there I was, an official Manhattan resident at the ripe old age of twenty-two.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Did I have a job? Not yet. Did I have friends? Well, I was working on that. What mattered was that I was in New York City, and if I stretched out my bathroom window and turned ten degrees to the right, I could just make out the very top of the roof of the Plaza Hotel.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And maybe even catch a glimpse of Eloise.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33bfd489","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/prologue.vue
// module id = 90
// module chunks = 0